import { asyncTaskResultFile } from "@/network/network.jsx";
import { downloadFileFromData } from "@/other/utils/utils";

/**
 * Filename from `Content-Disposition`, matching the parser used for context markdown export.
 * Prefers `filename*`, then `filename`, then the caller fallback.
 */
export function filenameFromContentDisposition(
  header: string | undefined | null,
  fallback: string,
): string {
  if (!header) return fallback;

  const encoded = header.match(/filename\*\s*=\s*(?:UTF-8''|utf-8'')([^;\n]+)/i);
  if (encoded?.[1]) {
    const raw = encoded[1].trim().replace(/^["']|["']$/g, "");
    try {
      const decoded = decodeURIComponent(raw);
      if (decoded) return decoded;
    } catch {
      if (raw) return raw;
    }
  }

  const plain = header.match(/filename\s*=\s*"?([^";\n]+)"?/i);
  const name = plain?.[1]?.trim();
  return name || fallback;
}

export function boardExportFallbackFileName(boardName?: string | null): string {
  const name = boardName?.trim();
  return name ? `${name}-export.json` : "board-export.json";
}

/** Save `GET /async-task/{id}/result` as the attachment bytes. Does not parse JSON. */
export async function downloadBoardExportResult(
  taskId: number,
  fallbackFileName = "board-export.json",
): Promise<void> {
  const response = await asyncTaskResultFile(taskId);
  const disposition = response.headers?.["content-disposition"];
  const header = typeof disposition === "string" ? disposition : undefined;
  const fileName = filenameFromContentDisposition(header, fallbackFileName);
  const data: unknown = response.data;
  const blob =
    typeof Blob !== "undefined" && data instanceof Blob
      ? data
      : new Blob([data as BlobPart], { type: "application/json" });
  downloadFileFromData(blob, fileName);
}
